import React from 'react';

import { Box, COLORS, Text } from '@clutter/clean';

import { Block, BlockProps } from '@shared/page_builder/block';

export const SimpleHeading: React.FC<
  {
    title: React.ReactNode;
    background?: string;
    textColor?: string;
  } & BlockProps
> = ({
  title,
  background = COLORS.moss,
  textColor = COLORS.cloud,
  ...blockProps
}) => {
  return (
    <Block background={background} textAlign="center" {...blockProps}>
      <Box margin="0 0 32px">
        <Text.Title size="large" color={textColor}>
          {title}
        </Text.Title>
      </Box>
    </Block>
  );
};
